var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _circle4, _circle5, _rect8, _rect9, _text, _circle6, _circle7, _rect10, _rect11, _path, _path2, _path3, _text2, _text3, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    width: 800,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A2540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1E3A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentGradient",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5AA9FF"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#bgGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 180,
    width: 100,
    height: 220,
    rx: 6,
    fill: "#0F3360",
    stroke: "#0078FF",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 200,
    width: 80,
    height: 20,
    rx: 2,
    fill: "#1E3A8A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 240,
    width: 80,
    height: 20,
    rx: 2,
    fill: "#1E3A8A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 280,
    width: 80,
    height: 20,
    rx: 2,
    fill: "#1E3A8A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 320,
    width: 80,
    height: 20,
    rx: 2,
    fill: "#1E3A8A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 360,
    width: 80,
    height: 20,
    rx: 2,
    fill: "#1E3A8A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 192,
    r: 4,
    fill: "#0078FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 232,
    r: 4,
    fill: "#0078FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 272,
    r: 4,
    fill: "#0078FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 312,
    r: 4,
    fill: "#0078FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 575,
    cy: 352,
    r: 4,
    fill: "#0078FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 160,
    width: 200,
    height: 140,
    rx: 8,
    fill: "#0F3360",
    stroke: "#0078FF",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 170,
    width: 180,
    height: 120,
    rx: 4,
    fill: "#F5F7FA"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 200,
    fontSize: 16,
    fill: "#0A2540",
    fontFamily: "Arial, sans-serif"
  }, "\n    { error: \"Unhandled Exception\" }\n  ")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 420,
    r: 40,
    fill: "url(#accentGradient)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 420,
    r: 40,
    fill: "url(#accentGradient)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 360,
    width: 20,
    height: 60,
    fill: "#0078FF",
    rx: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 360,
    width: 20,
    height: 60,
    fill: "#0078FF",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310 390 C350 350, 400 350, 450 390",
    stroke: "#5AA9FF",
    strokeWidth: 3,
    fill: "none",
    strokeDasharray: "6,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270 420 L280 400 L300 400",
    stroke: "#F5F7FA",
    strokeWidth: 2,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550 420 L540 400 L520 400",
    stroke: "#F5F7FA",
    strokeWidth: 2,
    fill: "none"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 170,
    fontSize: 40,
    fontFamily: "monospace",
    fill: "#0078FF"
  }, "{ }")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 220,
    fontSize: 14,
    fontFamily: "monospace",
    fill: "#F5F7FA"
  }, "&lt;code&gt;fixing&lt;/code&gt;")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 140,
    fill: "none",
    stroke: "url(#accentGradient)",
    strokeOpacity: 0.3,
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDev);
export default __webpack_public_path__ + "static/media/web-dev.03f7c048f9731191b606e0f52aaf41f8.svg";
export { ForwardRef as ReactComponent };